import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class UIDragdropService<T> {
    isDragging = false;
    dragData: T[];
}
